module.exports = __webpack_public_path__ + "static/media/dot_green.e902b632.svg";